import script from "./LedgerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LedgerPage.vue?vue&type=script&setup=true&lang=js"

import "./LedgerPage.vue?vue&type=style&index=0&id=3f269b13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f269b13"]])

export default __exports__